import store from "@/store";
import {YearTitles, Fields} from "@/models/configuration"
import {SettingAssessment, SettingAssessmentKey} from "@/models/settingAssessment"
import { JS } from "aws-amplify";

class Grades {
  static from(object, settingAssessment) {
    try {
      return new Grades(object);
    } catch (err) {
      let type = settingAssessment
      const values = {
        "grade_1": type.grade1,
        "grade_2": type.grade2,
        "grade_3": type.grade3,
        "grade_4": type.grade4,
        "grade_5": type.grade5,
        "grade_6": type.grade6,
        "grade_7": type.grade7,
        "grade_8": type.grade8,
        "grade_9": type.grade9
      }

        return new Grades(values)
     }
  }

  constructor(initializer) {
    this.id = initializer.id
    this.values = [
     {legacy_key: "bronze", key: "grade_1", title: "Grade 1", value: initializer.grade_1, score: 1, used: true, protect: true, color: 'ef6c00', text_color: 'orange-800', chart_color: '#E4C289'},
     {legacy_key: "silver", key: "grade_2", title: "Grade 2", value: initializer.grade_2, score: 2, used: true, protect: true, color: '616161', text_color: 'gray-700', chart_color:  '#D2D0D3'},
     {legacy_key: "gold", key: "grade_3", title: "Grade 3", value: initializer.grade_3, score: 3, used: true, protect: true,  color: 'fdd835', text_color: 'yellow-600', chart_color: '#EEDB91'},
     {legacy_key: "greater", key: "grade_4", title: "Grade 4", value: initializer.grade_4, score: 4, used: initializer.grade_4 != undefined, color: '00796b', text_color: 'teal-700', chart_color: '#E4C289'},
     { key: "grade_5", title: "Grade 5", value: initializer.grade_5, score: 5, used: initializer.grade_5 != undefined, color: '388e3c', text_color: 'green-700', chart_color: '#E4C289'},
     { key: "grade_6", title: "Grade 6", value: initializer.grade_6, score: 6, used: initializer.grade_6 != undefined, color: '1976d2', text_color: 'blue-700', chart_color: '#E4C289'},
     { key: "grade_7", title: "Grade 7", value: initializer.grade_7, score: 7, used: initializer.grade_7 != undefined, color: '1976d2', text_color: 'blue-700', chart_color: '#E4C289'},
     { key: "grade_8", title: "Grade 8", value: initializer.grade_8, score: 8, used: initializer.grade_8 != undefined, color: '1976d2', text_color: 'blue-700',  chart_color: '#E4C289'},
     { key: "grade_9", title: "Grade 9", value: initializer.grade_9, score: 9, used: initializer.grade_9 != undefined, color: '1976d2', text_color: 'blue-700', chart_color: '#E4C289'},
    ]
  }
  
}

class Criteria {
  static from(object, settingAssessment) {

    try {
     return new Criteria(object);
   } catch (err) {
    let type = settingAssessment

    const values = {
      "criteria_1": type.criteria1,
      "criteria_2": type.criteria2,
      "criteria_3": type.criteria3,
      "criteria_4": type.criteria4,
      "criteria_5": type.criteria5,
      "display_order": ["criteria_2", "criteria_1", "criteria_3", "criteria_4", "criteria_5"],
    }
     return new Criteria(values)
   }
 }

 constructor(initializer) {
   this.id = initializer.id
   let results = [
    { key: "criteria_1", title: "Criteria 1", value: initializer.criteria_1, used: true, protect: true},
    { key: "criteria_2", title: "Criteria 2", value: initializer.criteria_2, used: true, protect: true},
    { key: "criteria_3", title: "Criteria 3", value: initializer.criteria_3, used: true, protect: true},
    { key: "criteria_4", title: "Criteria 4", value: initializer.criteria_4, used: initializer.criteria_4 != undefined},
    { key: "criteria_5", title: "Criteria 5", value: initializer.criteria_5, used: initializer.criteria_4 != undefined},
   ]

   if (initializer.display_order == undefined) {
    this.values = results
   } else {
    this.values = results.sort((a, b) => initializer.display_order.indexOf(a.key) - initializer.display_order.indexOf(b.key));
   }
 }
}

class SettingAssessmentType {
  static from(object) {
    try {
      return new SettingAssessmentType(object)
    } catch (err) {
      const values = {
        "id": 1,
        "title": "PEPA",
        "key": "pepa"
      }
      return new SettingAssessmentType(values)
    }
  }

  constructor(initializer) {
    this.id = initializer.id
    this.title = initializer.title
    this.key = initializer.key_value
  }

}


export default class Settings {
  static from(results) {
    try {
      return new Settings(results);
    } catch (err) {
      //console.log("error - no settings data", err);
      return err
    }
  }

  constructor(initializer) {
    // console.log("SETTINGS INITAL", JSON.stringify(initializer))
  
    let settings = initializer.settings
    this.id = settings.id
    this.yearTitlesList = YearTitles.from(settings.year_titles);
    this.fieldDisplayList = Fields.from(settings.course_fields);
    this.courses = settings.course_criteria;
    this.outcomes = settings.outcome_criteria;
    this.planningLocked = settings.is_planning_locked;
    this.planningLevel = settings.planning_level;
    this.gcseActive = settings.is_gcse_active;
    this.gcseBoard = settings.gcse_board;
    this.assessmentCustom = settings.is_assessment_custom
    this.assessmentType = SettingAssessmentType.from(settings.assessment_type)
    this.allow_free = settings.allow_free

    let assessment = SettingAssessment.from(this.assessmentType.key)
    this.assessmentGrades = Grades.from(initializer.grades, assessment)
    this.assessmentCriteria = Criteria.from(initializer.criteria, assessment)
  }

  get planningDisplayLevel() {
    return this.planningLevel;
  }

  get isPlanningLocked() {
    return this.planningLocked === true;
  }

  get isAllowedFree() {

    if (this.allow_free === undefined || this.allow_free === null) {
      return true 
    } else {
      return this.allow_free === true
    }  
  }

  get isAssessmentCustom() {
    return this.assessmentCustom === true;
  }

  get isGcseActive() {
    return this.gcseActive === true;
  }

  get courseDisplayType() {
    return this.courses;
  }

  get outcomeDisplayType() {
    return this.outcomes;
  }

  get assessmentCriteriaList() {
    return this.assessmentCriteria.values
  }

  get assessmentGradesList() {
    return this.assessmentGrades.values
  }

}